import { render, staticRenderFns } from "./page-content-type-wine_product_faq.vue?vue&type=template&id=bd384488&scoped=true"
import script from "./page-content-type-wine_product_faq.vue?vue&type=script&lang=js"
export * from "./page-content-type-wine_product_faq.vue?vue&type=script&lang=js"
import style0 from "./page-content-type-wine_product_faq.vue?vue&type=style&index=0&id=bd384488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd384488",
  null
  
)

export default component.exports